module.exports = __webpack_public_path__ + "img/signature.d8d251a.webp";